module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/logo-aoj-ja-0c34b5c739c50400e8f16b9efb2f84bb.svg";